export default __webpack_public_path__ + "static/media/cyra-master-plan.bb7e31a1.jpeg";